import { render } from './render'

import bundle = require('./bundle.json')
import system = require('./system.json')

render(bundle, system)
